import { render, staticRenderFns } from "./host-business-opportunity.vue?vue&type=template&id=5527dc2c&scoped=true&"
import script from "./host-business-opportunity.vue?vue&type=script&lang=js&"
export * from "./host-business-opportunity.vue?vue&type=script&lang=js&"
import style0 from "./host-business-opportunity.vue?vue&type=style&index=0&id=5527dc2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5527dc2c",
  null
  
)

export default component.exports